"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formik = require("formik");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var execHandler = function execHandler(handler, e) {
  return handler ? handler(e) : undefined;
};
function Select(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasContent = _useState2[0],
    setHasContent = _useState2[1];
  var disabled = props.disabled,
    className = props.className,
    name = props.name,
    id = props.id,
    label = props.label,
    options = props.options,
    onChange = props.onChange,
    onBlur = props.onBlur,
    onFocus = props.onFocus,
    _props$disableLabel = props.disableLabel,
    disableLabel = _props$disableLabel === void 0 ? false : _props$disableLabel,
    _props$availableFirst = props.availableFirstValue,
    availableFirstValue = _props$availableFirst === void 0 ? false : _props$availableFirst,
    value = props.value,
    labelClassName = props.labelClassName,
    optionKeyField = props.optionKeyField,
    multiple = props.multiple,
    _props$showFirstValue = props.showFirstValue,
    showFirstValue = _props$showFirstValue === void 0 ? true : _props$showFirstValue,
    _props$firstValueLabe = props.firstValueLabel,
    firstValueLabel = _props$firstValueLabe === void 0 ? null : _props$firstValueLabe;
  var _useField = (0, _formik.useField)({
      name: name,
      type: 'select'
    }),
    _useField2 = _slicedToArray(_useField, 3),
    field = _useField2[0],
    meta = _useField2[1],
    helpers = _useField2[2];
  var error = meta.error,
    touched = meta.touched;
  var setValue = helpers.setValue,
    setTouched = helpers.setTouched;
  var handleInputFocus = (0, _react.useCallback)(function (e) {
    execHandler(onFocus, e);
  }, [onFocus]);
  var handleInputBlur = (0, _react.useCallback)(function (e) {
    setTouched(true);
    setHasContent(!(0, _isEmpty2["default"])(e.target.value));
    execHandler(onBlur, e);
  }, [setTouched, onBlur]);
  var handleChange = (0, _react.useCallback)(function (e) {
    setValue(e.target.value);
    setHasContent(!(0, _isEmpty2["default"])(e.target.value));
    execHandler(onChange, e);
  }, [setValue, onChange]);
  var hasValue = (0, _react.useMemo)(function () {
    return !(0, _isEmpty2["default"])(field.value);
  }, [field.value]);
  var hasError = (0, _react.useMemo)(function () {
    return touched && error;
  }, [touched, error]);
  var isLabelVisible = (0, _react.useMemo)(function () {
    return hasError || hasContent || hasValue;
  }, [hasError, hasContent, hasValue]);
  var groupCln = (0, _react.useMemo)(function () {
    return (0, _classnames["default"])('form-group', className);
  }, [className]);
  var labelCln = (0, _react.useMemo)(function () {
    return (0, _classnames["default"])('col-form-label', hasError && error && 'text-danger', labelClassName);
  }, [hasError, error, labelClassName]);
  var selectCln = (0, _react.useMemo)(function () {
    return (0, _classnames["default"])('custom-select', (hasContent || hasValue) && 'custom-select--with-content', hasError && 'custom-select--error');
  }, [hasContent, hasValue, hasError]);
  var errorCln = (0, _react.useMemo)(function () {
    return (0, _classnames["default"])('col-form-error', hasError && error && 'text-danger');
  }, [hasError, error]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: groupCln
  }, label && !disableLabel && /*#__PURE__*/_react["default"].createElement("label", {
    style: {
      visibility: "".concat(isLabelVisible ? 'visible' : 'hidden')
    },
    className: labelCln,
    htmlFor: id
  }, label), /*#__PURE__*/_react["default"].createElement("select", {
    disabled: disabled,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    onChange: handleChange,
    value: value || field.value || '0',
    className: selectCln,
    name: name,
    id: id,
    multiple: multiple
  }, showFirstValue && /*#__PURE__*/_react["default"].createElement("option", {
    disabled: !availableFirstValue,
    value: availableFirstValue ? '' : 0
  }, firstValueLabel || label), options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: optionKeyField ? option[optionKeyField] : option.value,
      disabled: option.disabled,
      value: option.value
    }, option.label);
  })), hasError && /*#__PURE__*/_react["default"].createElement("label", {
    className: errorCln,
    htmlFor: id
  }, hasError));
}
Select.propTypes = {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  options: _propTypes["default"].arrayOf(_propTypes["default"].object),
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func
};
Select.defaultProps = {
  options: []
};
var _default = exports["default"] = Select;